// @flow

import {
  createMediaField,
  messageField,
  subjectField,
  taskField,
} from 'app/get-help/content/nodes/common';

type DefaultUserInputOverrides = {
  message?: {},
  media?: {},
  task?: boolean | {},
};

export const createDefaultContact = (
  { message, media, task }: DefaultUserInputOverrides = {
    message: {},
    media: {},
    task: {},
  }
) => {
  const items = [
    {
      ...subjectField,
    },
    {
      ...messageField,
      label: `Please describe the issue you're seeing in detail.`,
      details: `What is happening? What are you trying to accomplish with this Zap?`,
      ...message,
    },
    createMediaField({
      ...media,
    }),
  ];
  if (typeof task !== 'boolean' || task === true) {
    items.push({
      ...taskField,
      label:
        'Is there an example from your Zap History that illustrates the problem?',
      ...(typeof task === 'boolean' ? {} : task),
    });
  }
  return items;
};
